import type { ColumnWithFilter } from "../../Components/FilterBar/FilterBar";
import type { LookupTableOption } from "../../Components/DataEntry/Select/LookupTableSelect";
import {
  formatLookupDistance,
  getLookupTableText,
} from "./helpers";

export const buildRouteBaseLookupOption = (routeBase: any) => ({
  ...routeBase,
  label: routeBase?.code,
  value: routeBase?._id,
  title: JSON.stringify({
    receiptAddress: routeBase?.receipt?.address,
    deliveryAddress: routeBase?.delivery?.address,
    direction: routeBase?.direction,
  }),
  raw: routeBase,
});

const routeBaseTableColumns: ColumnWithFilter<LookupTableOption>[] = [
  {
    title: "Mã tuyến",
    dataIndex: "code",
    filterDataIndex: "searchText",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập mã tuyến",
      },
    },
    width: 130,
    render: (_value, record) => getLookupTableText(record, "code"),
  },
  {
    title: "Khu vực",
    dataIndex: "regionName",
    filterDataIndex: "region",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập khu vực",
      },
    },
    width: 140,
    render: (_value, record) =>
      getLookupTableText(record, "regionName") ||
      getLookupTableText(record, ["region", "name"]),
  },
  {
    title: "Chiều hàng",
    dataIndex: "direction",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập chiều hàng",
      },
    },
    width: 120,
    render: (_value, record) => getLookupTableText(record, "direction"),
  },
  {
    title: "Hình thức VC",
    dataIndex: "roadType",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập hình thức vận chuyển",
      },
    },
    width: 140,
    render: (_value, record) => getLookupTableText(record, "roadType"),
  },
  {
    title: "Điểm nhận",
    dataIndex: ["receipt", "address"],
    filterDataIndex: "receipt",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập điểm nhận",
      },
    },
    width: 240,
    render: (_value, record) => getLookupTableText(record, ["receipt", "address"]),
  },
  {
    title: "Điểm trả",
    dataIndex: ["delivery", "address"],
    filterDataIndex: "delivery",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập điểm trả",
      },
    },
    width: 240,
    render: (_value, record) => getLookupTableText(record, ["delivery", "address"]),
  },
  {
    title: "Km có hàng",
    dataIndex: "haveGoodsDistance",
    width: 120,
    render: (_value, record) =>
      formatLookupDistance(getLookupTableText(record, "haveGoodsDistance")),
  },
  {
    title: "Km không hàng",
    dataIndex: "noGoodsDistance",
    width: 130,
    render: (_value, record) =>
      formatLookupDistance(getLookupTableText(record, "noGoodsDistance")),
  },
];

export const routeBaseLookupTable = {
  popupWidth: 1180,
  searchPlaceholder: "Tìm theo mã tuyến",
  tableColumns: routeBaseTableColumns,
};
